import { COUNTRY_STATES_DICTIONARY } from "../statesConstants";
import type { CountryCode } from "@config/site/types";
import { SALUTATIONS_DICTIONARY } from "../Salutation/salutationConstants";
import type { State } from "../RegionField";

export function getStatesByLocale(locale: string): State[] {
    return COUNTRY_STATES_DICTIONARY[locale] || [];
}
export function getStatesByCountry(countryCode: string): State[] {
    const countryLocales = Object.keys(COUNTRY_STATES_DICTIONARY).filter((key) =>
        key.endsWith(`-${countryCode}`)
    );

    const enLocale = countryLocales.find((locale) => locale.startsWith("en-"));

    // If no English locale is found, return the first available locale
    return COUNTRY_STATES_DICTIONARY[enLocale || countryLocales[0]] || [];
}
export function getStates(countryCode: CountryCode, locale: string): State[] {
    const localeCountry = locale.split("-")[1];

    return localeCountry === countryCode
        ? getStatesByLocale(locale)
        : getStatesByCountry(countryCode);
}

export function getSalutation(locale: string) {
    return SALUTATIONS_DICTIONARY[locale] || [];
}

export const getSalutationName = (value: string, locale: string) => {
    const resolvedCountry = getSalutation(locale);
    if (!resolvedCountry) {
        return "";
    }
    const salutation = resolvedCountry.find((salutation) => salutation.value === value);
    return salutation ? salutation.name : "Salutation not found";
};

export const getMarketSearchField = (country: string) => {
    if (country === "JP") return "postalCode";
    return "address1";
};

export const getAddressLookupFieldKey = (country: string) => {
    if (country === "JP") return "postalCode";
    return "streetName";
};
